import React from "react";
import { getRegistrationKeys } from "../../utils/utils";
import { useSubject } from "../../context/SubjectContext";
import { useCenter } from "../../context/CenterContext";

export function formatUnitCodes(units) {
  if (!units || units.length === 0) return "";
  if (units.length === 1) return units[0];
  if (units.length === 2) return `${units[0]} and ${units[1]}`;
  // 3 or more
  const allButLast = units.slice(0, -1).join(", ");
  const last = units[units.length - 1];
  return `${allButLast} and ${last}`;
}

const getErrorMessage = (
  values,
  showConsortiaError,
  currentCentreType,
  isConsortiumRegistered,
  isMixed,
  isConsortiaRestCandidateRegistered,
  isConsortiumUnitsSelected,
  formData,
) => {
  let errorMessage = "";
  if (currentCentreType === "Lead" && showConsortiaError) {
    if (
      Boolean(isConsortiaRestCandidateRegistered === false) &&
      isConsortiumUnitsSelected
    )
      errorMessage =
        "A visit request cannot be created for consortia unit(s) where registration entries have not been received for all sub-centres within the consortium.";
    else if (isMixed)
      errorMessage =
        "A visit request cannot contain both consortia and non consortia units. Please amend your unit selection accordingly.";
    else if (isConsortiumRegistered)
      errorMessage =
        "A visit request cannot be created for consortia unit(s) where a consortia request has not been submitted.";
    else if (isConsortiumUnitsSelected && formData.isConsortium === "no")
      errorMessage =
        "A visit request cannot be created for consortia unit(s) when the assessment of these units is not being carried out with other centres as part of a consortium.";
  }

  if (
    (values && values.length > 0) ||
    (values.invalidUnitCodes && values.invalidUnitCodes.length > 0)
  ) {
    errorMessage = `The following unit code(s) are not valid: ${formatUnitCodes(values.invalidUnitCodes)}. Please amend your unit selection accordingly.`;
  }

  return errorMessage;
};

const ErrorMessageContainer = ({
  formData,
  values,
  showConsortiaError = false,
  currentCentreType = "",
  isConsortiumRegistered,
  isMixed,
  isConsortiumUnitsSelected,
}) => {
  const { subjectData } = useSubject();
  const registrationKeys = getRegistrationKeys(
    currentCentreType,
    subjectData.subjectDetails,
  );
  const { isConsortiaRestCandidateRegistered } = registrationKeys;
  if (
    getErrorMessage(
      values,
      showConsortiaError,
      currentCentreType,
      isConsortiumRegistered,
      isMixed,
      isConsortiaRestCandidateRegistered,
      isConsortiumUnitsSelected,
      formData,
    )
  )
    return (
      <div id="pnlUnitErrorMessage" style={{ display: "block" }}>
        <div className="notification is-danger is-flex">
          <span className="icon mr-4">
            <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"></path>
            </svg>
          </span>
          <span>
            <strong>Error</strong>
            <br />
            <span id="varErrorMessage">
              {getErrorMessage(
                values,
                showConsortiaError,
                currentCentreType,
                isConsortiumRegistered,
                isMixed,
                isConsortiaRestCandidateRegistered,
                isConsortiumUnitsSelected,
                formData,
              )}
            </span>
          </span>
        </div>
      </div>
    );
  else return null;
};

export default ErrorMessageContainer;
